import React from "react";
import { Table as AntdTable } from "antd";
// import LoaderInline from "./loader";
import Loader from "./loader";

const CustomTable = ({ loading, dataSource, columns, pageSize = 5 }) => {
  return (
    <div className="bg-white rounded ">
      {loading ? (
        <Loader />
      ) : (
        <AntdTable
          dataSource={dataSource}
          columns={columns}
          pagination={{ pageSize }}
          //   loading={loading}
          scroll={{ x: "max-content" }}
        />
      )}
    </div>
  );
};

export default CustomTable;
